module.exports = __webpack_public_path__ + "img/18fb670.png";